<template>
  <div ref="pageView" class="page-view">
    <application-content-detail
      ref="applicationContent"
      pageType="examine"
    ></application-content-detail>
  </div>
</template>

<script>
// api
import { getBookingDetailById } from "@/api/businessApplication";
// components
import applicationContentDetail from "./components/applicationContentDetail.vue";
export default {
  components: { applicationContentDetail },
  data() {
    return {
      bookingId: "",
      loading: false,
      detailData: {},
    };
  },
  created() {
    this.bookingId = Number(this.$route.query.bookingId);
    this.getDetail();
  },
  mounted() {},
  methods: {
    // 查询详情数据
    async getDetail() {
      try {
        this.loading = true;
        let res = await getBookingDetailById({ bookingId: this.bookingId });

        if (res.code) {
          this.detailData = res.result;
          this.$refs.applicationContent.init(this.detailData);
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.page-view {
  height: 100%;
  overflow: auto;
}
</style>
